import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '~/store/app.store';

const limitNotificationsItemSelector = (state: AppState) => state.frontendState.limitNotifications.notifications;
export const useLimitNotificationsItemSelector = () => useSelector(limitNotificationsItemSelector);
